import { Field, Section } from '@app/models/module-structure';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.less'],
})
export class CardsComponent implements OnInit {
  @Input() lines;
  @Input() section: Section;
  @Input() itemCodeField;
  @Input() moduleStructure;
  @Input() recordModel;
  @Input() countedField;
  @Input() quantityField;
  @Input() actionType;
  @Input() fieldGroupKeys;
  @Input() fieldGroups;
  @Input() enablePaginationInLineSection: boolean = false;
  @Input() pageSizeInLineSection: number = 10;
  @Output() deleteRowEmitter = new EventEmitter();
  @Output() editRowEmitter = new EventEmitter();
  @Output() getSpanValEmitter = new EventEmitter();
  @Output() getPushValEmitter = new EventEmitter();
  @Output() getPullValEmitter = new EventEmitter();

  currentPage: number = 1;
  paginatedLines: any[] = [];
  fieldsToRender: Field[];

  constructor() {}

  ngOnInit(): void {
    this.updatePaginatedLines();

    this.fieldsToRender = this.section.Fields.filter(
      (field) => field.AdditionalInformationParsed.SendToMobileApp
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['lines']) {
      console.log('Lines changed:', changes['lines'].currentValue);
      this.updatePaginatedLines();
    }
  }

  deleteRow(id) {
    this.deleteRowEmitter.emit(id);
  }

  editRow(data, visible) {
    this.editRowEmitter.emit(data);
  }

  getSpanVal(fieldKey) {
    this.getSpanValEmitter.emit(fieldKey);
  }

  getPushVal(fieldKey) {
    this.getPushValEmitter.emit(fieldKey);
  }

  getPullVal(fieldKey) {
    this.getPullValEmitter.emit(fieldKey);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.updatePaginatedLines();
  }

  updatePaginatedLines(): void {
    if (this.enablePaginationInLineSection) {
      const startIndex = (this.currentPage - 1) * this.pageSizeInLineSection;
      const endIndex = startIndex + this.pageSizeInLineSection;
      this.paginatedLines = this.lines.slice(startIndex, endIndex);
    } else {
      this.paginatedLines = this.lines;
    }
  }
}
